import { useEffect, useRef, useCallback } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { requestNotificationPermission, onForegroundMessage } from "@/lib/firebase";

export const NotificationManager = () => {
  const { user, api } = useAuth();
  const initialized = useRef(false);

  const registerPush = useCallback(async () => {
    if (!user || initialized.current) return;
    initialized.current = true;

    // Only auto-subscribe if user already granted permission previously
    // (don't trigger native popup on login - PushDiscoveryBanner handles that)
    if (typeof Notification === "undefined" || Notification.permission !== "granted") return;

    try {
      const token = await requestNotificationPermission();
      if (token) {
        await api.post("/push/subscribe", {
          endpoint: token,
          keys: { fcm: true },
        });
      }
    } catch (e) {
      // Push notifications not supported or denied
    }
  }, [user, api]);

  useEffect(() => {
    registerPush();
  }, [registerPush]);

  // Handle foreground messages
  useEffect(() => {
    if (!user) return;

    const unsubscribe = onForegroundMessage((payload) => {
      const title = payload.notification?.title || payload.data?.title || "ReallyFan";
      const body = payload.notification?.body || payload.data?.body || "";

      // Show in-app notification
      if (Notification.permission === "granted") {
        new Notification(title, {
          body,
          icon: "/favicon.png",
        });
      }
    });

    return unsubscribe;
  }, [user]);

  return null;
};
